import React from "react";
import ProviderProfile from "../components/ProviderProfile";
import useProviderProfile from "../hooks/useProviderProfile";

const ProviderContainer: React.FC = () => {
  const { provider, loading, error } = useProviderProfile();

  if (loading) return <p>Loading provider information...</p>;
  if (error) return <p style={{ color: "red" }}>Error: {error}</p>;
  if (!provider) return <p style={{ color: "red" }}>Error: {error}</p>;

  return <ProviderProfile providerData={provider} />;
};

export default ProviderContainer;
